export var ActivityWalletLimitType;
(function (ActivityWalletLimitType) {
    ActivityWalletLimitType["GAME_CATEGORY"] = "game_category";
    ActivityWalletLimitType["GAME"] = "game";
})(ActivityWalletLimitType || (ActivityWalletLimitType = {}));
//# sourceMappingURL=ActivityWalletLimitType.js.map